export default __webpack_public_path__ + "882eebfdf7523986825f70cd8d75a523.png";